export default __webpack_public_path__ + "static/media/logoutBanner.c49fa884.png";